// extracted by mini-css-extract-plugin
export default {"button":"button_button__veIpW","special":"button_special__wHWfG","primary":"button_primary__-KixE","secondary":"button_secondary__T1Ny9"};